var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFellowshipPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95703 17.9179C9.95703 18.7541 10.1217 19.582 10.4417 20.3545C10.7617 21.127 11.2307 21.8289 11.8219 22.4202C12.4132 23.0114 13.1151 23.4804 13.8876 23.8004C14.6601 24.1204 15.488 24.2851 16.3242 24.2851C17.1603 24.2851 17.9883 24.1204 18.7608 23.8004C19.5333 23.4804 20.2352 23.0114 20.8264 22.4202C21.4177 21.8289 21.8867 21.127 22.2066 20.3545C22.5266 19.582 22.6913 18.7541 22.6913 17.9179C22.6913 16.2293 22.0205 14.6097 20.8264 13.4157C19.6324 12.2216 18.0128 11.5508 16.3242 11.5508C14.6355 11.5508 13.016 12.2216 11.8219 13.4157C10.6279 14.6097 9.95703 16.2293 9.95703 17.9179Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0586 21.1015C29.0586 22.368 29.5617 23.5827 30.4573 24.4782C31.3528 25.3738 32.5674 25.8769 33.834 25.8769C35.1005 25.8769 36.3151 25.3738 37.2106 24.4782C38.1062 23.5827 38.6093 22.368 38.6093 21.1015C38.6093 19.835 38.1062 18.6204 37.2106 17.7248C36.3151 16.8293 35.1005 16.3262 33.834 16.3262C32.5674 16.3262 31.3528 16.8293 30.4573 17.7248C29.5617 18.6204 29.0586 19.835 29.0586 21.1015Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.837 30.6523C30.6073 30.6523 27.752 32.2556 26.0234 34.7095C26.944 36.3306 27.4696 38.2054 27.4696 40.2031C27.4696 41.1358 27.355 42.0422 27.139 42.9081C32.7865 41.672 37.571 38.1296 40.4557 33.3176C38.7391 31.6671 36.4065 30.6523 33.837 30.6523Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6941 43.3866C16.0228 43.3866 10.0889 40.2298 6.30469 35.328C8.11296 31.6174 11.9214 29.0605 16.327 29.0605C22.4808 29.0605 27.4695 34.0492 27.4695 40.203C27.4695 41.1358 27.3548 42.0422 27.1388 42.9081C25.7071 43.2214 24.2199 43.3866 22.6941 43.3866Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6932 43.3864C11.2647 43.3864 2 34.1219 2 22.6932C2 11.2647 11.2647 2 22.6932 2C34.1219 2 43.3864 11.2647 43.3864 22.6932C43.3864 34.1219 34.1219 43.3864 22.6932 43.3864Z",
    stroke: "#215250",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFellowshipPro);
export default __webpack_public_path__ + "static/media/fellowship-pro.990962b8e099b635a4538993de52a521.svg";
export { ForwardRef as ReactComponent };